import {
  FormControlLabel,
  FormGroup,
  Checkbox,
  Grid,
  TextField,
 
  Box,
  FormControl,
 
  MenuItem,
  Button,
  FormHelperText,
  Typography,
  Chip,
  
} from "@mui/material";
import { React, useRef, useEffect, useState } from "react";


import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import BackButton from "../../common/button/backButton";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";

import { useDispatch, useSelector } from "react-redux";
import masterFormsActions from "../../redux/masterForms/actions"; 
import masterActions from "../../redux/master/actions";
import dayjs from "dayjs";

import CreateMasterModal from "../masterForm/modals/createMasterModal";


import eligibilityCriteriaActions from "../../redux/eligibilityCriteria/actions";
export default function AddEligibility() {
  const navigate = useNavigate();
  const location = useLocation();
  let id = location?.state?.id;

  const now = new Date();
  const dispatch = useDispatch();
  const today = new Date();
  const date = new Date();
  const currentYear = date.getFullYear();
  const [years, setYears] = useState([]);

  const {
    categoryList,
    pwdtypeList,
    gspecializationSubjectList,
    familyincomeList,
    cetExamList,
    educationStreamList,
    cetExamListById,
    pgBranchList,
    graduationBranchList
  } = useSelector((state) => state.masterFormsReducer);
  const { eligibilityCriteria } = useSelector(
    (state) => state.eligibilityCriteriaReducer
  );  

  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);
  const { courseList } = useSelector((state) => state.masterReducer);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    trigger,
    control,
    setError,
    resetField,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      criteria_option: "",
      enableNationality: false,
      nationality: "",
      enableMhCandidate : false,
      appliedforews:"",
      enableEws:false,
      ismhcandidate : "",
      enableCategory : false,
      categoryid : [],
      familyincomeid:"",
      enableIncomeRange:false,
      enableOrphan : false,
      isorphan : "",
      isdisability:"",
      enableDisabilityType: false,
      enableHscPassingStatus: false,
      enableeligibilityqualificationid:false,
      enablepgstatus:false,
      pgstatus:"",
      enablegraduationstatus:false,
      graduationstatus:"",
      eligibilityqualificationid:"",
      operator_code_fi:"",
      hscpassingstatus:"",
      error_message:"",
      enableErrorMessage:false,
      // enableOperator: false,
      cetexamname:"",
      courseid:"",
      enableCourse:false,
      enableCetExamName:false,
      ispgmh:"",
      enableGraduationFromMaharashtra:false,
      enableDisability : false,
      disabilitytypeid : [],
      enableHSC: false,
      hscpercentage: "",
      hscyearofpassing: "",
      hscminage: "",
      hscmaxage: "",
      hscason: null,
      enableUG: false,
      enablePG:false,
      ugpercentage: "",
      ugyearofpassing: "",
      ugminage: "",
      ugmaxage: "",
      ugason: null,
      pgpercentage: "",
      pgyearofpassing: "",
      pgminage: "",
      pgmaxage: "",
      pgason: null,
      graduationbranchid: [],
      pgbranchid: []
    },
  });

  console.log(watch("pgbranchid"),"graudationbranchid cosmleddd")

  

  // useEffect(() => {

  //   if (id && eligibilityCriteria?.length > 0) {
  //     let data = eligibilityCriteria?.find(
  //       (obj) => obj.eligibilitycriteriaid == id
  //     );
  //     reset({
  //       ...data,
  //     });
  //     setValue("hscason", dayjs(data.hscason));
  //     setValue("ugason", dayjs(data.ugason));
  //     setValue("pgason", dayjs(data.pgason));
  //     setValue(
  //       "disabilitytypeid",
  //       data?.disabilitytypeid?.map((i) => i.toString())
  //     );
  //     setValue("compulsorysubject", data.compulsorysubject);
  //     setValue(
  //       "categoryid",
  //       data?.categoryid?.map((i) => i.toString())
  //     );
  //   }
  // }, [eligibilityCriteria, id, reset, setValue]);



  useEffect(() => {
    if (id && eligibilityCriteria?.length > 0) {
      let data = eligibilityCriteria?.find(
        (obj) => obj.eligibilitycriteriaid == id
      );
      console.log(data?.pgpercentage, data?.pgyearofpassing, data?.pgminage, data?.pgmaxage, data?.pgason, data?.pgbranchid, data?.graduationbranchid,  "poiuytrewqwertyuiojhgfdfghjk")
      reset({
        ...data,
        criteria_option: data?.criteria_option ?? "",
        enableNationality: !!data?.nationality, 
        nationality: data?.nationality ?? "",
        enableMhCandidate : !!data?.ismhcandidate,
        ismhcandidate: data?.ismhcandidate ?? "",
        enableCategory : !!data?.categoryid,
        categoryid: data?.categoryid ?? "",
        enableOrphan : !!data?.isorphan,
        isorphan: data?.isorphan ?? "",
        isdisability: data?.isdisability ?? "",
        enableDisabilityType: !!data?.isdisability,
        enableHscPassingStatus: !!data?.hscpassingstatus,
        enableeligibilityqualificationid: !!data?.eligibilityqualificationid,
        enablepgstatus: !!data?.pgstatus,
        pgstatus: data?.pgstatus ?? "",
        enablegraduationstatus: !!data?.graduationstatus,
        graduationstatus: data?.graduationstatus ?? "",
        eligibilityqualificationid: data?.eligibilityqualificationid ?? "",
        hscpassingstatus: data?.hscpassingstatus ?? "",
        error_message: data?.error_message ?? "",
        enableErrorMessage: !!data?.error_message,
        courseid: data?.courseid ?? "",
        enableCourse: !!data?.courseid,
        cetexamname: data?.cetexamname ?? "",
        enableCetExamName: !!data?.cetexamname,
        operator_code_fi: data?.operator_code_fi ?? "",
        // enableOperator: !!data?.operator_code_fi,
        appliedforews: data?.appliedforews ?? "",
        EnableEws:!!data?.appliedforews,
        ispgmh: data?.ispgmh ?? "",
        enableGraduationFromMaharashtra: !!(data?.ispgmh?.toString()),
        familyincomeid: data?.familyincomeid ?? "",
        enableIncomeRange: !!data?.familyincomeid,
        enableDisability : !!data?.disabilitytypeid,
        disabilitytypeid: data?.disabilitytypeid ?? "",
        enableHSC: !!data?.hscpercentage || !!data?.hscyearofpassing || !!data?.hscminage || !!data?.hscmaxage || !!data?.hscason || (Array.isArray(data?.hscstream) && data?.hscstream?.length > 0),
        enableUG: !!data?.ugpercentage || data?.ugyearofpassing || data?.ugminage || data?.ugmaxage || data?.ugason || (Array.isArray(data?.graduationbranchid) && data?.graduationbranchid?.length > 0),
        enablePG: !!data?.pgpercentage || data?.pgyearofpassing || data?.pgminage || data?.pgmaxage || data?.pgason || (Array.isArray(data?.pgbranchid) && data?.pgbranchid?.length > 0),



        hscason: data.hscason ? dayjs(data.hscason) : null,
        ugason: data.ugason ? dayjs(data.ugason) : null,
        pgason: data.pgason ? dayjs(data.pgason) : null,
        disabilitytypeid: data?.disabilitytypeid?.map((i) => i.toString()) || [],
        compulsorysubject: data?.compulsorysubject?.map((i) => i.toString()) || [],
        hscstream: data?.hscstream?.map((i) => i.toString()) || [],
        categoryid: data?.categoryid?.map((i) => i.toString()) || [],
        familyincomeid: data?.familyincomeid || null,
        graduationbranchid: data?.graduationbranchid?.map((i) => i.toString()) || [],
        pgbranchid: data?.pgbranchid?.map((i) => i.toString()) || [],

      });
    }
  }, [eligibilityCriteria, id, reset]);
  

  useEffect(() => {
    dispatch({ type: masterFormsActions.GET_NATIONALITY });
    dispatch({ type: masterFormsActions.GET_CATEGORY });
    dispatch({ type: masterFormsActions.GET_PWDTYPE });
    dispatch({ type: masterFormsActions.GET_GSPECIALIZATION_SUBJECT });
    dispatch({ type: masterFormsActions.GET_FAMILYINCOME });
    dispatch({ type: masterActions.GET_COURSE_LIST });
    dispatch({ type: masterFormsActions.GET_CET_EXAM });
    dispatch({ type: masterFormsActions.GET_EDUCATION_STREAM });
    dispatch({ type: masterFormsActions.GET_POST_GRADUATION_BRANCH });
    dispatch({ type: masterFormsActions.GET_GRADUATION_BRANCH });

    if (location.search === "?page=updateeligibility") {
      dispatch({
        type: eligibilityCriteriaActions.GET_ELIGIBILITY_CRITERIA,
      });
    }

    const getYears = () => {
      const array = [];
      for (let i = 1945; i <= currentYear; i++) {
        array.push(i);
      }
      return array;
    };
    setYears(getYears());
  }, []);

  const resetForm = () => {
    setValue("coursedriveid", "");
    setValue("coursecategoryid", "");

    reset({});
  };

  useEffect(() => {
    if (id) {
      let { prerequisite, ...course } =
        eligibilityCriteria?.all?.find(
          (obj) => obj.eligibilitycriteriaid === id
        ) || {};
    }
  }, [setValue, eligibilityCriteria, id]);

  
  const handleAddEligibility = (data) => {
    // If criteria_option is Rejection (0), clear all HSC/UG/PG fields
    if (data.criteria_option == 0) {
      data.enableHSC = false;
      data.hscpercentage = null;
      data.hscyearofpassing = null;
      data.hscminage = null;
      data.hscmaxage = null;
      data.hscason = null;
      
      data.enableUG = false;
      data.ugpercentage = null;
      data.ugyearofpassing = null;
      data.ugminage = null;
      data.ugmaxage = null;
      data.ugason = null;
      data.compulsorysubject = null;
      data.hscstream = null;
      
      data.enablePG = false;
      data.pgpercentage = null;
      data.pgyearofpassing = null;
      data.pgminage = null;
      data.pgmaxage = null;
      data.pgason = null;
    }

    data.criteria_option = parseInt(data.criteria_option);
    data.nationality = data.enableNationality ? parseInt(data.nationality) : null;
    data.ismhcandidate = data.enableMhCandidate ? parseInt(data.ismhcandidate) : null;
    data.isorphan = data.enableOrphan ? parseInt(data.isorphan) : null;
    data.isdisability = data.enableDisabilityType ? parseInt(data.isdisability) : null;
    data.hscpassingstatus = data.enableHscPassingStatus ? (data.hscpassingstatus) : null;
    data.eligibilityqualificationid = data.enableeligibilityqualificationid ? (data.eligibilityqualificationid) : null;
    data.pgstatus = data.enablepgstatus ? (data.pgstatus) : null;
    data.graduationstatus = data.enablegraduationstatus ? (data.graduationstatus) : null;
    data.error_message = data?.enableErrorMessage ? (data.error_message) : null;
    data.operator_code_fi = parseInt(data.operator_code_fi);
    data.courseid = data.enableCourse ? parseInt(data.courseid) : null;
    data.cetexamname = data.enableCetExamName ? parseInt(data.cetexamname) : null;
    data.appliedforews = data.EnableEws ? parseInt(data.appliedforews) : null;
    data.ispgmh = data.enableGraduationFromMaharashtra ? parseInt(data.ispgmh) : null;
    data["userid"] = backofficeTokenDetails?.id;

    dispatch({
      type: eligibilityCriteriaActions.CREATE_ELIGIBILITY_CRITERIA,
      payload: { data: data, navigate: navigate, resetForm: resetForm },
    });
  };

  const handleUpdateEligibility = (data) => {
    // If criteria_option is Rejection (0), clear all HSC/UG/PG fields
    if (data.criteria_option == 0) {
      data.enableHSC = false;
      data.hscpercentage = null;
      data.hscyearofpassing = null;
      data.hscminage = null;
      data.hscmaxage = null;
      data.hscason = null;
      
      data.enableUG = false;
      data.ugpercentage = null;
      data.ugyearofpassing = null;
      data.ugminage = null;
      data.ugmaxage = null;
      data.ugason = null;
      data.compulsorysubject = null;
      data.hscstream = null;
      
      data.enablePG = false;
      data.pgpercentage = null;
      data.pgyearofpassing = null;
      data.pgminage = null;
      data.pgmaxage = null;
      data.pgason = null;
    }
    
    data.criteria_option = parseInt(data.criteria_option);
    data.nationality = data.enableNationality ? parseInt(data.nationality) : null;
    data.ismhcandidate = data.enableMhCandidate ? parseInt(data.ismhcandidate) : null;
    data.isorphan = data.enableOrphan ? parseInt(data.isorphan) : null;
    data.isdisability = data.enableDisabilityType ? parseInt(data.isdisability) : null;
    data.hscpassingstatus = data.enableHscPassingStatus ? (data.hscpassingstatus) : null;
        data.eligibilityqualificationid = data.enableeligibilityqualificationid ? (data.eligibilityqualificationid) : null;
        data.pgstatus = data.enablepgstatus ? (data.pgstatus) : null;
        data.graduationstatus = data.enablegraduationstatus ? (data.graduationstatus) : null;
    data.error_message = data?.enableErrorMessage ? (data.error_message) : null;
    data.operator_code_fi = parseInt(data.operator_code_fi);
    data.courseid = data.enableCourse ? parseInt(data.courseid) : null;
    data.cetexamname = data.enableCetExamName ? parseInt(data.cetexamname) : null;
    data.appliedforews = data.EnableEws ? parseInt(data.appliedforews) : null;
    data.ispgmh = data.enableGraduationFromMaharashtra ? parseInt(data.ispgmh) : null;
    data["userid"] = backofficeTokenDetails?.id;

    dispatch({
      type: eligibilityCriteriaActions.UPDATE_ELIGIBILITY_CRITERIA,
      payload: { data: data, navigate: navigate, resetForm: resetForm },
    });
  };



  // const handleAddEligibility = (data) => {


  //   data.nationality = data.enableNationality ? data.nationality : null;
  // data.ismhcandidate = data.enableMhCandidate ? data.ismhcandidate : null;
  // data.isorphan = data.enableOrphan ? data.isorphan : null;


  //   data["userid"] = backofficeTokenDetails?.id;

  //   dispatch({
  //     type: eligibilityCriteriaActions.CREATE_ELIGIBILITY_CRITERIA,
  //     payload: { data: data, navigate: navigate, resetForm: resetForm },
  //   });
  // };

  // const handleUpdateEligibility = (data) => {
  //   data["userid"] = backofficeTokenDetails?.id;


    
  //   data.nationality = data.enableNationality ? parseInt(data.nationality ): null;
  // data.ismhcandidate = data.enableMhCandidate ? parseInt(data.ismhcandidate) : null;
  // data.isorphan = data.enableOrphan ? parseInt(data.isorphan) : null;

  //   dispatch({
  //     type: eligibilityCriteriaActions.UPDATE_ELIGIBILITY_CRITERIA,
  //     payload: { data: data, navigate: navigate, resetForm: resetForm },
  //   });
  // };
  

  const handleChange = (e) => {
    const value = e.target.value;
    const isDuplicate = eligibilityCriteria.some(
      (item) =>
        item.eligibilitycriterianame.toLowerCase() === value.toLowerCase()
    );
  
    if (isDuplicate) {
      setError("eligibilitycriterianame", {
        type: "manual",
        message: "Eligibility Criteria Name already exists",
      });
    } else {
      clearErrors("eligibilitycriterianame");
    }
  };

  const criteriaOption = watch("criteria_option");
  const parsedOption = Number(criteriaOption);

const shouldRenderNothing =
  criteriaOption === undefined ||
  criteriaOption === null ||
  criteriaOption === "" ||
  isNaN(parsedOption) ||
  parsedOption === 2;

  
useEffect(() => {
  setValue("nationality", null);
  setValue("enableNationality", false);
  setValue("ismhcandidate", null);
  setValue("enableMhCandidate", false);
  setValue("categoryid", []); 
  setValue("enableCategory", false);
  setValue("isorphan", null);
  setValue("enableOrphan", false);
  setValue("isdisability", null);
  setValue("enableDisabilityType", false)
   setValue("disabilitytypeid", []);
   setValue("enableDisability", false); 
   setValue("appliedforews", null );
   setValue("EnableEws", false);
   setValue("ispgmh", null);
   setValue("enableGraduationFromMaharashtra", false);
   setValue("familyincomeid", null); 
   setValue("enableIncomeRange", false);
   setValue("courseid", null);
   setValue("enableCourse", false);
   setValue("cetexamname", null);
   setValue("enableCetExamName", false);
   setValue("error_message", null);
   setValue("enableErrorMessage", false);
   setValue("hscpassingstatus", null);
   setValue("enableHscPassingStatus", false);
   setValue("enableeligibilityqualificationid", false);
   setValue("enablepgstatus", false);
   setValue("pgstatus", null);
   setValue("enablegraduationstatus", false);
   setValue("graduationstatus", null);
   setValue("eligibilityqualificationid", null);
   setValue("operator_code_fi", null);
   setValue("enableHSC", false);
  setValue("enableUG", false);
  setValue("enablePG", false);
  setValue("hscpercentage", null);
  setValue("hscyearofpassing", null);
  setValue("hscminage", null);
  setValue("hscmaxage", null);
  setValue("hscason", null);
  setValue("hscstream", null);
  setValue("compulsorysubject", null);

  setValue("ugpercentage", "");
  setValue("ugyearofpassing", "");
  setValue("ugminage", "");
  setValue("ugmaxage", "");
  setValue("ugason", null);
  setValue("pgpercentage", "");
  setValue("pgyearofpassing", "");
  setValue("pgminage", "");
  setValue("pgmaxage", "");
  setValue("pgason", null);
  setValue("graduationbranchid", []);
  setValue("pgbranchid", []);
}, [watch("criteria_option")]);


useEffect(() => {
  if (watch("courseid")) {
    dispatch({
      type: masterFormsActions.GET_CET_EXAM_BY_ID,
      courseid: watch("courseid"),
    });
  }
}, [watch("courseid")]);







  
  return (
    <>
      <Typography variant="h5" mb={3}>
        Eligibility Criteria Information
      </Typography>

      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={8}>
          <TextField
            sx={{ width: "126%", height: "50px" }}
            {...register("eligibilitycriterianame", {
              required: "Eligibility Criteria Name is required",
              onChange: handleChange
            })}
            InputLabelProps={{
              shrink: !!watch("eligibilitycriterianame"),
            }}
            error={!!errors.eligibilitycriterianame}
            helperText={errors.eligibilitycriterianame?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Eligibility Criteria Name
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>

        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControl fullWidth>
              <TextField
                select
                label={
                  <span>
                    Select Criteria Option
                    <span className="error" style={{ color: "red" }}>*</span>
                  </span>
                }
                {...register("criteria_option", {
                  required: "Criteria Option is required",
                })}
                defaultValue={watch("criteria_option") || ""}
                value={watch("criteria_option") ?? ""}
                error={!!errors.criteria_option}
                helperText={errors.criteria_option?.message}
                sx={{ width: "100%", height: "55px" }}
              >
                <MenuItem value="" disabled>
                  Select One
                </MenuItem>
                <MenuItem value={0}>Rejection</MenuItem>
                <MenuItem value={1}>Minimum</MenuItem>
                <MenuItem value={2}>Success</MenuItem>
              </TextField>
            </FormControl>
          </Box>
        </Grid>

{shouldRenderNothing ? null : (
          <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enableNationality")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableNationality", isChecked);
                    setValue("nationality", isChecked ? "" : null);
                  }}
                />
              }
              label="Enable Nationality Selection"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.nationality}
              disabled={!watch("enableNationality")}
              sx={{ marginLeft: "4%" }}
            >
              <Controller
                name="nationality"
                control={control}
                rules={{
                  required: watch("enableNationality")
                    ? "Select Nationality required"
                    : false,
                }}
                render={({ field }) => (
                  <TextField
                    select
                    label="Select Nationality"
                    value={field.value ?? ""}
                    onChange={(e) => field.onChange(e.target.value)}
                    disabled={!watch("enableNationality")}
                    sx={{ width: "100%", height: "55px" }}
                  >
                    <MenuItem value="" disabled>
                      Select One
                    </MenuItem>
                    <MenuItem value={1}>Indian</MenuItem>
                    <MenuItem value={0}>NRI</MenuItem>
                  </TextField>
                )}
              />
              <FormHelperText>{errors.nationality?.message}</FormHelperText>
            </FormControl>
          </Box>
        </Grid>
)}

{shouldRenderNothing ? null : (
        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enableMhCandidate")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableMhCandidate", isChecked);
                    setValue("ismhcandidate", isChecked ? "" : null);
                  }}
                />
              }
              label="Enable State Domicile Candidate"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.ismhcandidate}
              disabled={!watch("enableMhCandidate")}
            >
              <Controller
                name="ismhcandidate"
                control={control}
                rules={{
                  required: watch("enableMhCandidate")
                    ? "Select State DomicileCandidate required"
                    : false,
                }}
                render={({ field }) => (
                  <TextField
                    select
                    label="Select State Domicile Candidate"
                    value={field.value ?? ""}
                    onChange={(e) => field.onChange(e.target.value)}
                    disabled={!watch("enableMhCandidate")}
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value="" disabled>
                      Select One
                    </MenuItem>
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </TextField>
                )}
              />
              <FormHelperText>{errors.ismhcandidate?.message}</FormHelperText>
            </FormControl>
          </Box>
        </Grid>
)}

{shouldRenderNothing ? null : (
        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enableCategory")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableCategory", isChecked);
                    if (!isChecked) {
                      setValue("categoryid", []); 
                    }
                  }}
                                  />
              }
              label="Enable Category Selection"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.categoryid}
              disabled={!watch("enableCategory")}
              sx={{ marginLeft: "5%" }}
            >
              <Controller
                name="categoryid"
                control={control}
                rules={{
                  required: watch("enableCategory")
                    ? "Category required"
                    : false,
                }}
                defaultValue={[]}
                render={({ field }) => (
                  <TextField
                    select
                    fullWidth
                    label="Select Category"
                    SelectProps={{
                      multiple: true,
                      value: Array.isArray(field.value) ? field.value : [],
                      onChange: (e) => {
                        const selectedValues = Array.isArray(e.target.value)
                          ? e.target.value
                          : [e.target.value];
                        field.onChange(selectedValues);
                      },
                      renderValue: (selected) => (
                        <Box
                          sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        >
                          {selected.map((value) => {
                            const selectedCategory = categoryList?.all?.find(
                              (cat) =>
                                parseInt(cat.categoryid) === parseInt(value)
                            );

                            return (
                              <Chip
                                key={value}
                                label={selectedCategory?.category || "Unknown"}
                              />
                            );
                          })}
                        </Box>
                      ),
                    }}
                    error={!!errors.categoryid}
                    sx={{ width: "100%" }}
                    disabled={!watch("enableCategory")}
                  >
                    <MenuItem key="" value="" disabled>
                      Select Category
                    </MenuItem>
                    {categoryList?.all?.map((obj) => (
                      <MenuItem
                        key={obj.categoryid?.toString()}
                        value={obj.categoryid?.toString()}
                      >
                        {obj.category}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
              <FormHelperText>{errors.categoryid?.message}</FormHelperText>
            </FormControl>
          </Box>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.categoryid?.message}
          </FormHelperText>
        </Grid>
)}


{shouldRenderNothing ? null : (
        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enableOrphan")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableOrphan", isChecked);
                    setValue("isorphan", isChecked ? "" : null);
                  }}
                />
              }
              label="Enable Orphan Selection"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.isorphan}
              sx={{ marginLeft: "6%" }}
            >
              <Controller
                name="isorphan"
                control={control}
                rules={{
                  required: watch("enableOrphan")
                    ? "Select is Orphan required"
                    : false,
                }}
                render={({ field }) => (
                  <TextField
                    select
                    fullWidth
                    label="Select Is Orphan"
                    SelectProps={{
                      value: field.value ?? "",
                      onChange: (e) => field.onChange(e.target.value),
                    }}
                    error={!!errors.isorphan}
                    disabled={!watch("enableOrphan")}
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value="" disabled>
                      Select One
                    </MenuItem>
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </TextField>
                )}
              />
              <FormHelperText>{errors.isorphan?.message}</FormHelperText>
            </FormControl>
          </Box>
        </Grid>
)}

{shouldRenderNothing ? null : (
        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 6 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enableDisabilityType")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableDisabilityType", isChecked);
                    setValue("isdisability", isChecked ? "" : null);
                  }}
                />
              }
              label="Select Disability"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.isdisability}
              sx={{ marginLeft: "10%" }}
            >
              <Controller
                name="isdisability"
                control={control}
                rules={{
                  required: watch("enableDisabilityType")
                    ? "Select Disability"
                    : false,
                }}
                render={({ field }) => (
                  <TextField
                    select
                    fullWidth
                    label="Select Disability"
                    SelectProps={{
                      value: field.value ?? "",
                      onChange: (e) => field.onChange(e.target.value),
                    }}
                    error={!!errors.isdisability}
                    disabled={!watch("enableDisabilityType")}
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value="" disabled>
                      Select One
                    </MenuItem>
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </TextField>
                )}
              />
              <FormHelperText>{errors.isdisability?.message}</FormHelperText>
            </FormControl>
          </Box>
        </Grid>
)}

{shouldRenderNothing ? null : (
        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
            {/* Checkbox to enable Disability selection */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={Number(watch("isdisability")) !== 1 ? false : watch("enableDisability")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableDisability", isChecked);
                    if (!isChecked) {
                      setValue("disabilitytypeid", []); 
                    }
                  }}
                />
              }
              label="Select Disability Sub-type"
              sx={{ whiteSpace: "nowrap" }}
              disabled={Number(watch("isdisability")) !== 1}
            />

            <FormControl
              fullWidth
              error={!!errors.pwdtypeid}
              disabled={!watch("enableDisability")}
            >
              <Controller
                name="disabilitytypeid"
                control={control}
                rules={{
                  required: watch("enableDisability")
                    ? "Disability required"
                    : false,
                }}
                defaultValue={[]}
                render={({ field }) => (
                  <TextField
                    select
                    fullWidth
                    label="Select Disability Sub-type"
                    sx={{ width: "94%", marginLeft: "42px" }}
                    SelectProps={{
                      multiple: true,
                      value: Number(watch("isdisability")) !== 1 ? [] : Array.isArray(field.value) ? field.value : [],
                      onChange: (e) => {
                        const selectedValues = Array.isArray(e.target.value)
                          ? e.target.value
                          : [e.target.value];
                        field.onChange(selectedValues);
                      },
                      renderValue: (selected) => (
                        <Box
                          sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        >
                          {selected.map((value) => {
                            const selectedDisability = pwdtypeList?.all?.find(
                              (item) =>
                                parseInt(item.pwdtypeid) === parseInt(value)
                            );
                            return (
                              <Chip
                                key={value}
                                label={selectedDisability?.pwdtype || "Unknown"}
                              />
                            );
                          })}
                        </Box>
                      ),
                    }}
                    error={!!errors.pwdtypeid}
                    helperText={errors.pwdtypeid?.message}
                    // disabled={!watch("enableDisability")}
                    disabled={Number(watch("isdisability")) !== 1}
                  >
                    <MenuItem key="" value="" disabled>
                      Select Disability Type
                    </MenuItem>

                    {pwdtypeList?.all?.map((obj) => (
                      <MenuItem
                        key={obj.pwdtypeid?.toString()}
                        value={obj.pwdtypeid?.toString()}
                      >
                        {obj.pwdtype}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </FormControl>
          </Box>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.pwdtypeid?.message}
          </FormHelperText>
        </Grid>
)}

{shouldRenderNothing ? null : (
          <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("EnableEws")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("EnableEws", isChecked);
                    setValue("appliedforews", isChecked ? "" : null);
                  }}
                />
              }
              label="Enable EWS Selection"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.appliedforews}
              sx={{ marginLeft: "6%" }}
            >
              <Controller
                name="appliedforews"
                control={control}
                rules={{
                  required: watch("EnableEws")
                    ? "Select is Ews required"
                    : false
                }}
                render={({ field }) => (
                  <TextField
                    select
                    fullWidth
                    label="Select Is EWS"
                    SelectProps={{
                      value: field.value ?? "",
                      onChange: (e) => field.onChange(e.target.value),
                    }}
                    error={!!errors.appliedforews}
                    disabled={!watch("EnableEws")}
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value="" disabled>
                      Select One
                    </MenuItem>
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </TextField>
                )}
              />
              <FormHelperText>{errors.appliedforews?.message}</FormHelperText>
            </FormControl>
          </Box>
        </Grid>
)}

        {shouldRenderNothing ? null : (
          <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enableGraduationFromMaharashtra")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableGraduationFromMaharashtra", isChecked);
                    setValue("ispgmh", isChecked ? "" : null);
                  }}
                />
              }
              label="Maharashtra Graduation"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.ispgmh}
              sx={{ marginLeft: "6%" }}
            >
              <Controller
                name="ispgmh"
                control={control}
                rules={{
                  required: watch("enableGraduationFromMaharashtra")
                    ? "Select is MH graduation required"
                    : false
                }}
                render={({ field }) => (
                  <TextField
                    select
                    fullWidth
                    label="Select Is MH graduation"
                    SelectProps={{
                      value: field.value ?? "",
                      onChange: (e) => field.onChange(e.target.value),
                    }}
                    error={!!errors.ispgmh}
                    disabled={!watch("enableGraduationFromMaharashtra")}
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value="" disabled>
                      Select One
                    </MenuItem>
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </TextField>
                )}
              />
              <FormHelperText>{errors.ispgmh?.message}</FormHelperText>
            </FormControl>
          </Box>
        </Grid>
)}

{shouldRenderNothing ? null : (
  <>
        <Grid item xs={12} md={10}>
          <div style={{display:"flex"}}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enableIncomeRange")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableIncomeRange", isChecked);
                    if (!isChecked) {
                      setValue("familyincomeid", null); 
                    }
                  }}
                                  />
              }
              label="Enable Family Income"
              sx={{ whiteSpace: "nowrap" }}
            />

<FormControl
  fullWidth
  error={!!errors.familyincomeid}
  disabled={!watch("enableIncomeRange")}
  sx={{ marginLeft: "8%", width: 460 }}
>
  <Controller
    name="familyincomeid"
    control={control}
    rules={{
      required: watch("enableIncomeRange") ? "Income Range required" : false,
    }}
    defaultValue=""
    render={({ field }) => (
      <TextField
        select
        fullWidth
        label="Select Income Range"
        value={field.value || ""}
        onChange={(e) => field.onChange(e.target.value)}
        error={!!errors.familyincomeid}
        sx={{ width: "100%" }}
        disabled={!watch("enableIncomeRange")}
      >
        <MenuItem value="" disabled>
          Select Income Range
        </MenuItem>
        {familyincomeList?.all?.map((obj) => (
          <MenuItem
            key={obj.familyincomeid?.toString()}
            value={obj.familyincomeid?.toString()}
          >
            {obj.incomerange}
          </MenuItem>
        ))}
      </TextField>
    )}
  />
  <FormHelperText>{errors.familyincomeid?.message}</FormHelperText>
</FormControl>

          </Box>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.familyincomeid?.message}
          </FormHelperText>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControl
              fullWidth
              error={!!errors.operator_code_fi}
              sx={{ marginLeft: "6%", width:200 }}
            >
              <Controller
                name="operator_code_fi"
                control={control}
                // rules={{
                //   required: watch("enableIncomeRange")
                //     ? "Select is Orphan required"
                //     : false,
                // }}
                render={({ field }) => (
                  <TextField
                    select
                    fullWidth
                    label="Select Operator"
                    SelectProps={{
                      value: field.value ?? "",
                      onChange: (e) => field.onChange(e.target.value),
                    }}
                    error={!!errors.operator_code_fi}
                    disabled={!watch("enableIncomeRange")}
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value="" disabled>
                      Select One
                    </MenuItem>
                    <MenuItem value={0}>No Operation</MenuItem>
                    <MenuItem value={1}>=</MenuItem>
                    <MenuItem value={2}>!=</MenuItem>
                   <MenuItem value={3}>{'<'}</MenuItem>
                    <MenuItem value={4}>{'<='}</MenuItem>
                    <MenuItem value={5}>{'>'}</MenuItem>
                    <MenuItem value={6}>{'>='}</MenuItem>
                  </TextField>
                )}
              />
              <FormHelperText>{errors.operator_code_fi?.message}</FormHelperText>
            </FormControl>
          </Box>
          </div>
        </Grid>
  </>
)}

{shouldRenderNothing ? null : (
        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enableCourse")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableCourse", isChecked);
                    setValue("courseid", isChecked ? "" : null);
                  }}
                />
              }
              label="Enable Course Selection"
              sx={{ whiteSpace: "nowrap" }}
            />

<FormControl
  fullWidth
  error={!!errors.courseid}
  disabled={!watch("enableCourse")}
  sx={{ marginLeft: "6%", }}
>
  <Controller
    name="courseid"
    control={control}
    // rules={{
    //   required: watch("enableCourse") ? "Course ID is required" : false,
    // }}
    rules={{
  required: "Course ID is required",
}}

    defaultValue=""
    render={({ field }) => (
      <TextField
        select
        fullWidth
        label="Select Course"
        value={field.value || ""}
        // onChange={(e) => field.onChange(e.target.value)}
        onChange={(e) => {
        const selectedCourseId = e.target.value;
        field.onChange(selectedCourseId);
        dispatch({
          type: masterFormsActions.GET_CET_EXAM_BY_ID,
          courseid: selectedCourseId,
        });
      }}
        error={!!errors.courseid}
        sx={{ width: "100%" }}
        disabled={!watch("enableCourse")}
      >
        <MenuItem value="" disabled>
          Select Course
        </MenuItem>
        {courseList?.all?.map((obj) => (
          <MenuItem
            key={obj.courseid?.toString()}
            value={obj.courseid?.toString()}
          >
            {obj.coursename}
          </MenuItem>
        ))}
      </TextField>
    )}
  />
  <FormHelperText>{errors.courseid?.message}</FormHelperText>
</FormControl>
          </Box>
        </Grid>
)}

{shouldRenderNothing ? null : (
        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                    disabled={!watch("courseid")}
                    checked={!watch("courseid") ? false : watch("enableCetExamName")}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setValue("enableCetExamName", isChecked);
                      setValue("cetexamname", isChecked ? "" : null);
                    }}
                />
              }
              label="Enable Examname Selection"
              sx={{ whiteSpace: "nowrap" }}
            />

<FormControl
  fullWidth
  error={!!errors.cetexamname}
  disabled={!watch("enableCetExamName")} 
  sx={{ marginLeft: "2.5%", }}
>
  <Controller
    name="cetexamname"
    control={control}
    rules={{
      required: watch("enableCetExamName") ? "CET Exam Name is required" : false,
    }}
   disabled={!watch("enableCetExamName")} 
    defaultValue=""
    render={({ field }) => (
      <TextField
        select
        fullWidth
        label="Select CET exam name"
        value={!watch("courseid") ? false : field.value}
        onChange={(e) => field.onChange(e.target.value)}
        error={!!errors.cetexamname}
        sx={{ width: "100%" }}
        disabled={!watch("enableCetExamName")} 
      >
        <MenuItem value="" disabled>
          Select CET Exam Name
        </MenuItem>
        {cetExamListById?.all?.map((obj) => (
          <MenuItem
            key={obj.cetexamid?.toString()}
            value={obj.cetexamid?.toString()}
          >
            {obj.cetexamname}
          </MenuItem>
        ))}
      </TextField>
    )}
  />
  <FormHelperText>{errors.cetexamname?.message}</FormHelperText>
</FormControl>
          </Box>
        </Grid>
)}

{shouldRenderNothing ? null : (
  <Grid item xs={12} md={10}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={watch("enableErrorMessage")}
            onChange={(e) => {
              const isChecked = e.target.checked;
              setValue("enableErrorMessage", isChecked);
              setValue("error_message", isChecked ? "" : null);
            }}
          />
        }
        label="Enable Error Message"
        sx={{ whiteSpace: "nowrap" }}
      />

      <FormControl
        fullWidth
        error={!!errors.error_message}
        disabled={!watch("enableErrorMessage")}
        sx={{ marginLeft: "6%" }}
      >
        <Controller
          name="error_message"
          control={control}
          rules={{
            required: watch("enableErrorMessage")
              ? "Error Message is required"
              : false,
          }}
          defaultValue=""
          render={({ field }) => (
            <TextField
              fullWidth
              label="Enter an error message"
              value={field.value || ""}
              onChange={field.onChange}
              error={!!errors.error_message}
              sx={{ width: "100%" }}
              disabled={!watch("enableErrorMessage")}
            />
          )}
        />
        <FormHelperText>{errors.error_message?.message}</FormHelperText>
      </FormControl>
    </Box>
  </Grid>
)}

{shouldRenderNothing ? null : (
        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enableHscPassingStatus")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableHscPassingStatus", isChecked);
                    setValue("hscpassingstatus", isChecked ? "" : null);
                  }}
                />
              }
              label="Enable appearing in HSC"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.hscpassingstatus}
              sx={{ marginLeft: "5%" }}
            >
              <Controller
                name="hscpassingstatus"
                control={control}
                rules={{
                  required: watch("enableHscPassingStatus")
                    ? "Select Hsc passing status"
                    : false,
                }}
                render={({ field }) => (
                  <TextField
                    select
                    fullWidth
                    label="Select HSC passing status"
                    SelectProps={{
                      value: field.value ?? "",
                      onChange: (e) => field.onChange(e.target.value),
                    }}
                    error={!!errors.hscpassingstatus}
                    disabled={!watch("enableHscPassingStatus")}
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value="" disabled>
                      Select One
                    </MenuItem>
                    <MenuItem value={"1"}>Appearing</MenuItem>
                    <MenuItem value={"0"}>Passed</MenuItem>
                  </TextField>
                )}
              />
              <FormHelperText>{errors.hscpassingstatus?.message}</FormHelperText>
            </FormControl>
          </Box>
        </Grid>
)}

{shouldRenderNothing ? null : (
        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enableeligibilityqualificationid")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableeligibilityqualificationid", isChecked);
                    setValue("eligibilityqualificationid", isChecked ? "" : null);
                  }}
                />
              }
              label="Enable Eligibility Qualification"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.eligibilityqualificationid}
              sx={{ marginLeft: "3%" }}
            >
              <Controller
                name="eligibilityqualificationid"
                control={control}
                rules={{
                  required: watch("enableeligibilityqualificationid")
                    ? "Select Eligibility Qualification"
                    : false,
                }}
                render={({ field }) => (
                  <TextField
                    select
                    fullWidth
                    label="Enable Eligibility Qualification"
                    SelectProps={{
                      value: field.value ?? "",
                      onChange: (e) => field.onChange(e.target.value),
                    }}
                    error={!!errors.eligibilityqualificationid}
                    disabled={!watch("enableeligibilityqualificationid")}
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value="" disabled>
                      Select One
                    </MenuItem>
                    <MenuItem value={"1"}>Graduation</MenuItem>
                    <MenuItem value={"2"}>Post Graduation</MenuItem>
                  </TextField>
                )}
              />
              <FormHelperText>{errors.eligibilityqualificationid?.message}</FormHelperText>
            </FormControl>
          </Box>
        </Grid>
)}


{/* {shouldRenderNothing ? null : (
        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enablegraduationstatus")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enablegraduationstatus", isChecked);
                    setValue("graduationstatus", isChecked ? "" : null);
                  }}
                />
              }
              label="Enable Graduation status"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.graduationstatus}
              sx={{ marginLeft: "4.5%" }}
            >
              <Controller
                name="graduationstatus"
                control={control}
                rules={{
                  required: watch("enablegraduationstatus")
                    ? "Select Graduation status"
                    : false,
                }}
                render={({ field }) => (
                  <TextField
                    select
                    fullWidth
                    label="Enable Graduation status"
                    SelectProps={{
                      value: field.value ?? "",
                      onChange: (e) => field.onChange(e.target.value),
                    }}
                    error={!!errors.graduationstatus}
                    disabled={!watch("enablegraduationstatus")}
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value="" disabled>
                      Select One
                    </MenuItem>
                    <MenuItem value={"1"}>Appearing</MenuItem>
                    <MenuItem value={"2"}>Passed</MenuItem>
                  </TextField>
                )}
              />
              <FormHelperText>{errors.graduationstatus?.message}</FormHelperText>
            </FormControl>
          </Box>
        </Grid>
)} */}


{/* {shouldRenderNothing ? null : (
        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 9 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enablepgstatus")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enablepgstatus", isChecked);
                    setValue("pgstatus", isChecked ? "" : null);
                  }}
                />
              }
              label="Enable PG status"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.pgstatus}
              sx={{ marginLeft: "4.5%" }}
            >
              <Controller
                name="pgstatus"
                control={control}
                rules={{
                  required: watch("enablepgstatus")
                    ? "Select PG status"
                    : false,
                }}
                render={({ field }) => (
                  <TextField
                    select
                    fullWidth
                    label="Enable PG status"
                    SelectProps={{
                      value: field.value ?? "",
                      onChange: (e) => field.onChange(e.target.value),
                    }}
                    error={!!errors.pgstatus}
                    disabled={!watch("enablepgstatus")}
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value="" disabled>
                      Select One
                    </MenuItem>
                    <MenuItem value={"1"}>Appearing</MenuItem>
                    <MenuItem value={"2"}>Passed</MenuItem>
                  </TextField>
                )}
              />
              <FormHelperText>{errors.pgstatus?.message}</FormHelperText>
            </FormControl>
          </Box>
        </Grid>
)} */}



















        {(watch("criteria_option") == 1 || watch("criteria_option") == 2) && (
          <>
        <Grid item xs={12} md={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={watch("enableHSC")}
                onChange={(e) => {
                  const isChecked = e.target.checked;

                  setValue("enableHSC", isChecked);
                  if (!isChecked) {
                    setValue("hscpercentage", "");
                    setValue("hscyearofpassing", "");
                    setValue("hscminage", "");
                    setValue("hscmaxage", "");
                    setValue("hscason", null);
                  }
                }}
              />
            }
            label="HSC"
            sx={{ whiteSpace: "nowrap" }}
          />
        </Grid>

        {/* percentage */}
        <Grid item xs={12} md={6}>
          <TextField
            {...register("hscpercentage", {
              // required: watch("enableHSC") ? "percentage is required" : false,
              validate: (value) => {
                return value
                  ? /^\d+$/.test(value) || "percentage must be numeric"
                  : true;
              },
            })}
            InputLabelProps={{
              shrink: !!watch("hscpercentage"),
            }}
            error={!!errors.hscpercentage}
            helperText={errors.hscpercentage?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            disabled={!watch("enableHSC")}
            label={
              <span>
                percentage
               
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("hscpercentage", value);
            }}
          />
        </Grid>

        {/* Year of Passing */}
        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            error={!!errors.hscyearofpassing}
            disabled={!watch("enableHSC")}
          >
            <Controller
              name="hscyearofpassing"
              control={control}
              // rules={{
              //   required: watch("enableHSC")
              //     ? "Year of passing is required"
              //     : false,
              // }}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  select
                  fullWidth
                  label="Passing Year Should be Greater then or Equal to"
                  size="small"
                  value={field.value}
                  onChange={(e) => field.onChange(e.target.value)}
                  error={!!errors.hscyearofpassing}
                  helperText={errors.hscyearofpassing?.message}
                  disabled={!watch("enableHSC")}
                >
                  <MenuItem value="" disabled>
                    Select One
                  </MenuItem>
                  {years.map((year) => (
                    <MenuItem key={year} value={year.toString()}>
                      {year}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            />
          </FormControl>
        </Grid>

        {/* Minimum Age */}
        <Grid item xs={12} md={6}>
          <TextField
            {...register("hscminage", {
              // required: watch("enableHSC") ? "Minimum Age required" : false,
              validate: (value) => {
                return value
                  ? /^\d+$/.test(value) || "Minimum Age must be numeric"
                  : true;
              },
            })}
            InputLabelProps={{
              shrink: !!watch("hscminage"),
            }}
            error={!!errors.hscminage}
            helperText={errors.hscminage?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            disabled={!watch("enableHSC")}
            label={
              <span>
                Minimum Age
                
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("hscminage", (value));
            }}
          />
        </Grid>

        {/* Maximum Age */}
        <Grid item xs={12} md={6}>
          <TextField
            {...register("hscmaxage", {
              // required: watch("enableHSC") ? "Maximum Age required" : false,
              validate: (value) => {
                return value
                  ? /^\d+$/.test(value) || "Maximum Age must be numeric"
                  : true;
              },
            })}
            InputLabelProps={{
              shrink: !!watch("hscmaxage"),
            }}
            error={!!errors.hscmaxage}
            helperText={errors.hscmaxage?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            disabled={!watch("enableHSC")}
            label={
              <span>
                Maximum Age
               
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("hscmaxage", (value));
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Controller
            name="hscason"
            control={control}
            // rules={{
            //   required: watch("enableHSC") ? "AS On date is required" : false,
            // }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      AS On Date
                      
                    </span>
                  }
                  format="DD/MM/YYYY"
                  onChange={(date) => field.onChange(date)}
                  disabled={!watch("enableHSC")}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.hscason,
                      helperText: errors.hscason?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>

          <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            disabled={!watch("enableHSC")}
          >
            <Controller
              name="hscstream"
              control={control}
             
              defaultValue={[]}
              render={({ field }) => (
                <TextField
                  select
                  label="Select Compulsory Stream"
                  fullWidth
                  size="small"
                  // InputProps={{
                  //   sx: {
                  //     height: "40px", 
                  //     padding: "0px", 
                  //   },
                  // }}
                                    sx={{
                    "& .MuiSelect-select": {
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "4px",
                      minHeight: "22px",
                      padding: "6px 8px !important",
                      alignItems: "flex-start",
                      overflow: "visible",
                      whiteSpace: "normal",
                    },

                    "& .MuiInputBase-root": {
                      height: "auto",
                      minHeight: "22px",
                      paddingTop: "2px",
                      paddingBottom: "4px",
                    },
                  }}
                  SelectProps={{
                    multiple: true,
                    value: Array.isArray(field.value) 
                      ? field.value.map(String) // Ensure all values are strings for consistent comparison
                      : [],
                    onChange: (e) => {
                      const selectedValues = Array.isArray(e.target.value)
                        ? e.target.value
                        : [e.target.value];
                      field.onChange(selectedValues);
                      setValue("hscpercentage", e.target.value);
                    },
                    renderValue: (selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((value) => {
                          const selectedSubject =
                            educationStreamList?.all?.find(
                              (sub) =>
                                String(sub.educationstreamid) === String(value)
                            );
                          return (
                            <Chip
                              key={value}
                              label={
                                selectedSubject?.educationstream || "Unknown"
                              }
                            />
                          );
                        })}
                      </Box>
                    ),
                  }}
                  disabled={!watch("enableHSC")}
                >
                  <MenuItem key="" value="" disabled>
                    Select Compulsory Stream
                  </MenuItem>

                  {educationStreamList?.all?.map((obj) => (
                    <MenuItem
                      key={obj.educationstreamid}
                      value={String(obj.educationstreamid)} // Convert to string here
                      >
                      {obj.educationstream}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            />
          </FormControl>

          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.gspecializationid?.message}
          </FormHelperText>
        </Grid>

        <Grid item xs={12} md={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={watch("enableUG")}
                onChange={(e) => {
                  setValue("enableUG", e.target.checked);
                  if (e.target.checked === false) {
                    setValue("ugpercentage", "");
                    setValue("ugyearofpassing", "");
                    setValue("ugminage", "");
                    setValue("ugmaxage", "");
                    setValue("ugason", null);
                    setValue("compulsorysubject", null);
                    setValue("hscstream",null);
                    setValue("graduationbranchid", []);
                  }
                }}
              />
            }
            label="UG"
            sx={{ whiteSpace: "nowrap" }}
          />
        </Grid>

        {/* percentage */}
        <Grid item xs={12} md={6}>
          <TextField
            {...register("ugpercentage", {
              // required: watch("enableUG") ? "percentage is required" : false,
              validate: (value) => {
                return value
                  ? /^\d+$/.test(value) || "percentage must be numeric"
                  : true;
              },
            })}
            InputLabelProps={{
              shrink: !!watch("ugpercentage"),
            }}
            error={!!errors.ugpercentage}
            helperText={errors.ugpercentage?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            disabled={!watch("enableUG")}
            label={
              <span>
                percentage
                
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("ugpercentage", value);
            }}
          />
        </Grid>

        {/* Year of Passing */}
        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            error={!!errors.ugyearofpassing}
            disabled={!watch("enableUG")}
          >
            <Controller
              name="ugyearofpassing"
              control={control}
              // rules={{
              //   required: watch("enableUG")
              //     ? "Year of passing is required"
              //     : false,
              // }}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  select
                  fullWidth
                  label="Passing Year Should be Greater then or Equal to "
                  size="small"
                  value={field.value}
                  onChange={(e) => field.onChange(e.target.value)}
                  error={!!errors.ugyearofpassing}
                  helperText={errors.ugyearofpassing?.message}
                  disabled={!watch("enableUG")}
                >
                  <MenuItem value="" disabled>
                    Select One
                  </MenuItem>
                  {years.map((year) => (
                    <MenuItem key={year} value={year.toString()}>
                      {year}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            />
          </FormControl>
        </Grid>

        {/* Minimum Age */}
        <Grid item xs={12} md={6}>
          <TextField
            {...register("ugminage", {
              // required: watch("enableUG") ? "Minimum Age required" : false,
              validate: (value) => {
                return value
                  ? /^\d+$/.test(value) || "Minimum Age must be numeric"
                  : true;
              },
            })}
            InputLabelProps={{
              shrink: !!watch("ugminage"),
            }}
            error={!!errors.ugminage}
            helperText={errors.ugminage?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            disabled={!watch("enableUG")}
            label={
              <span>
                Minimum Age
                
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("ugminage", (value));
            }}
          />
        </Grid>

        {/* Maximum Age */}
        <Grid item xs={12} md={6}>
          <TextField
            {...register("ugmaxage", {
              // required: watch("enableUG") ? "Maximum Age required" : false,
              validate: (value) => {
                return value
                  ? /^\d+$/.test(value) || "Maximum Age must be numeric"
                  : true;
              },
            })}
            InputLabelProps={{
              shrink: !!watch("ugmaxage"),
            }}
            error={!!errors.ugmaxage}
            helperText={errors.ugmaxage?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            disabled={!watch("enableUG")}
            label={
              <span>
                Maximum Age
                
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("ugmaxage", (value));
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Controller
            name="ugason"
            control={control}
            // rules={{
            //   required: watch("enableUG") ? "AS On date is required" : false,
            // }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      AS On Date
                     
                    </span>
                  }
                  format="DD/MM/YYYY"
                  onChange={(date) => field.onChange(date)}
                  disabled={!watch("enableUG")}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.ugason,
                      helperText: errors.ugason?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            disabled={!watch("enableUG")}
          >
            <Controller
              name="compulsorysubject"
              control={control}
             
              defaultValue={[]}
              render={({ field }) => (
                <TextField
                  select
                  label="Select Compulsory Subject"
                  fullWidth
                  size="small"
                  // InputProps={{
                  //   sx: {
                  //     height: "40px", 
                  //     padding: "0px", 
                  //   },
                  // }}
                    sx={{
                    "& .MuiSelect-select": {
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "4px",
                      minHeight: "22px",
                      padding: "6px 8px !important",
                      alignItems: "flex-start",
                      overflow: "visible",
                      whiteSpace: "normal",
                    },

                    "& .MuiInputBase-root": {
                      height: "auto",
                      minHeight: "22px",
                      paddingTop: "2px",
                      paddingBottom: "4px",
                    },
                  }}
                  SelectProps={{
                    multiple: true,
                    value: Array.isArray(field.value) 
                      ? field.value.map(String) // Ensure all values are strings for consistent comparison
                      : [],
                    onChange: (e) => {
                      const selectedValues = Array.isArray(e.target.value)
                        ? e.target.value
                        : [e.target.value];
                      field.onChange(selectedValues);
                    },
                    renderValue: (selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((value) => {
                          const selectedSubject =
                            gspecializationSubjectList?.all?.find(
                              (sub) =>
                                String(sub.gspecializationid) === String(value)
                            );
                          return (
                            <Chip
                              key={value}
                              label={
                                selectedSubject?.gspecializaiton || "Unknown"
                              }
                            />
                          );
                        })}
                      </Box>
                    ),
                  }}
                  disabled={!watch("enableUG")}
                >
                  <MenuItem key="" value="" disabled>
                    Select Compulsory Subject
                  </MenuItem>

                  {gspecializationSubjectList?.all?.map((obj) => (
                    <MenuItem
                      key={obj.gspecializationid}
                      value={String(obj.gspecializationid)} // Convert to string here
                      >
                      {obj.gspecializaiton}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            />
          </FormControl>

          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.gspecializationid?.message}
          </FormHelperText>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            disabled={!watch("enableUG")}
          >
            <Controller
              name="graduationbranchid"
              control={control}
             
              defaultValue={[]}
              render={({ field }) => (
                <TextField
                  select
                  label="Select Compulsory Branches"
                  fullWidth
                  size="small"
                  // InputProps={{
                  //   sx: {
                  //     height: "40px", 
                  //     padding: "0px", 
                  //   },
                  // }}
                    sx={{
                    "& .MuiSelect-select": {
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "4px",
                      minHeight: "22px",
                      padding: "6px 8px !important",
                      alignItems: "flex-start",
                      overflow: "visible",
                      whiteSpace: "normal",
                    },

                    "& .MuiInputBase-root": {
                      height: "auto",
                      minHeight: "22px",
                      paddingTop: "2px",
                      paddingBottom: "4px",
                    },
                  }}
                  SelectProps={{
                    multiple: true,
                    value: Array.isArray(field.value) 
                      ? field.value.map(String) // Ensure all values are strings for consistent comparison
                      : [],
                    onChange: (e) => {
                      const selectedValues = Array.isArray(e.target.value)
                        ? e.target.value
                        : [e.target.value];
                      field.onChange(selectedValues);
                    },
                    renderValue: (selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((value) => {
                          const selectedSubject =
                            graduationBranchList?.all?.find(
                              (sub) =>
                                String(sub.graduationbranchid) === String(value)
                            );
                          return (
                            <Chip
                              key={value}
                              label={
                                selectedSubject?.graduationbranch || "Unknown"
                              }
                            />
                          );
                        })}
                      </Box>
                    ),
                  }}
                  disabled={!watch("enableUG")}
                >
                  <MenuItem key="" value="" disabled>
                    Select Compulsory Branches
                  </MenuItem>

                  {graduationBranchList?.all?.map((obj) => (
                    <MenuItem
                      key={obj.graduationbranchid}
                      value={String(obj.graduationbranchid)} // Convert to string here
                      >
                      {obj.graduationbranch}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            />
          </FormControl>

          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.graduationbranchid?.message}
          </FormHelperText>
        </Grid>

        <Grid item xs={12} md={12}>
          <FormControlLabel
            control={
              <Checkbox
                // checked={watch("enablePG")}
                onChange={(e) => {
                  setValue("enablePG", e.target.checked);
                  if (e.target.checked === false) {
                    setValue("pgpercentage", "");
                    setValue("pgyearofpassing", "");
                    setValue("pgminage", "");
                    setValue("pgmaxage", "");
                    setValue("pgason", null);
                    setValue("pgbranchid", []);
                  }
                }}
              />
            }
            label="PG"
            sx={{ whiteSpace: "nowrap" }}
          />
        </Grid>

        {/* percentage */}
        <Grid item xs={12} md={6}>
          <TextField
            {...register("pgpercentage", {
              // required: watch("enablePG") ? "percentage is required" : false,
              validate: (value) => {
                return value
                  ? /^\d+$/.test(value) || "percentage must be numeric"
                  : true;
              },
            })}
            InputLabelProps={{
              shrink: !!watch("pgpercentage"),
            }}
            error={!!errors.pgpercentage}
            helperText={errors.pgpercentage?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            disabled={!watch("enablePG")}
            label={
              <span>
                percentage
                
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("pgpercentage", value);
            }}
          />
        </Grid>

        {/* Year of Passing */}
        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            error={!!errors.pgyearofpassing}
            disabled={!watch("enablePG")}
          >
            <Controller
              name="pgyearofpassing"
              control={control}
              // rules={{
              //   required: watch("enablePG")
              //     ? "Year of passing is required"
              //     : false,
              // }}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  select
                  fullWidth
                  label="Passing Year Should be Greater then or Equal to "
                  size="small"
                  value={field.value}
                  onChange={(e) => field.onChange(e.target.value)}
                  error={!!errors.pgyearofpassing}
                  helperText={errors.pgyearofpassing?.message}
                  disabled={!watch("enablePG")}
                >
                  <MenuItem value="" disabled>
                    Select One
                  </MenuItem>
                  {years.map((year) => (
                    <MenuItem key={year} value={year.toString()}>
                      {year}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            />
          </FormControl>
        </Grid>

        {/* Minimum Age */}
        <Grid item xs={12} md={6}>
          <TextField
            {...register("pgminage", {
              // required: watch("enablePG") ? "Minimum Age required" : false,
              validate: (value) => {
                return value
                  ? /^\d+$/.test(value) || "Minimum Age must be numeric"
                  : true;
              },
            })}
            InputLabelProps={{
              shrink: !!watch("pgminage"),
            }}
            error={!!errors.pgminage}
            helperText={errors.pgminage?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            disabled={!watch("enablePG")}
            label={
              <span>
                Minimum Age
                
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("pgminage", (value));
            }}
          />
        </Grid>

        {/* Maximum Age */}
        <Grid item xs={12} md={6}>
          <TextField
            {...register("pgmaxage", {
              // required: watch("enablePG") ? "Maximum Age required" : false,
              validate: (value) => {
                return value
                  ? /^\d+$/.test(value) || "Maximum Age must be numeric"
                  : true;
              },
            })}
            InputLabelProps={{
              shrink: !!watch("pgmaxage"),
            }}
            error={!!errors.pgmaxage}
            helperText={errors.pgmaxage?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            disabled={!watch("enablePG")}
            label={
              <span>
                Maximum Age
               
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("pgmaxage",  (value));
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Controller
            name="pgason"
            control={control}
            // rules={{
            //   required: watch("enablePG") ? "AS On date is required" : false,
            // }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      AS On Date
                     
                    </span>
                  }
                  format="DD/MM/YYYY"
                  onChange={(date) => field.onChange(date)}
                  disabled={!watch("enablePG")}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.pgason,
                      helperText: errors.pgason?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            disabled={!watch("enablePG")}
          >
            <Controller
              name="pgbranchid"
              control={control}
             
              defaultValue={[]}
              render={({ field }) => (
                <TextField
                  select
                  label="Select Compulsory Branches"
                  fullWidth
                  size="small"
                  // InputProps={{
                  //   sx: {
                  //     height: "40px", 
                  //     padding: "0px", 
                  //   },
                  // }}
                  sx={{
                    "& .MuiSelect-select": {
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "4px",
                      minHeight: "22px",
                      padding: "6px 8px !important",
                      alignItems: "flex-start",
                      overflow: "visible",
                      whiteSpace: "normal",
                    },

                    "& .MuiInputBase-root": {
                      height: "auto",
                      minHeight: "22px",
                      paddingTop: "2px",
                      paddingBottom: "4px",
                    },
                  }}
                  SelectProps={{
                    multiple: true,
                    value: Array.isArray(field.value) 
                      ? field.value.map(String) // Ensure all values are strings for consistent comparison
                      : [],
                    onChange: (e) => {
                      const selectedValues = Array.isArray(e.target.value)
                        ? e.target.value
                        : [e.target.value];
                      field.onChange(selectedValues);
                    },
                    // MenuProps: {
                    //   PaperProps: {
                    //     style: {
                    //       minHeight: 300,
                    //     },
                    //   },
                    // },
                    renderValue: (selected) => (
                      <Box sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.5,
                        maxHeight: "auto",
                        overflow: "visible",
                        alignItems: "flex-start",
                        paddingY: "4px",

                       }}>
                        {selected.map((value) => {
                          const selectedSubject =
                            pgBranchList?.all?.find(
                              (sub) =>
                                String(sub.pgbranchid) === String(value)
                            );
                          return (
                            <Chip
                              key={value}
                              label={selectedSubject?.pgbranch || "Unknown"}
                              size="small"
                              sx={{ minHeight: 22 }}
                            />
                          );
                        })}
                      </Box>
                    ),
                  }}
                  disabled={!watch("enablePG")}
                >
                  <MenuItem key="" value="" disabled>
                    Select Compulsory Branches
                  </MenuItem>

                  {pgBranchList?.all?.map((obj) => (
                    <MenuItem
                      key={obj.pgbranchid}
                      value={String(obj.pgbranchid)} // Convert to string here
                      >
                      {obj.pgbranch}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            />
          </FormControl>

          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.pgbranchid?.message}
          </FormHelperText>
        </Grid>
</>
        )}
      </Grid>
    
      <Grid
        item
        md={12}
        sx={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
      >
        <BackButton
          handleBack={() =>
            navigate(
              `/${Cookies.get(
                "mhet_mst_project"
              )}/eligibility-management?page=eligibilitycriteria`
            )
          }
        />
        <BluePrimaryButton
          handleSubmit={handleSubmit(
            location.search !== "?page=updateeligibility"
              ? handleAddEligibility
              : handleUpdateEligibility
          )}
          title={
            location.search === "?page=updateeligibility" ? "Update" : "Submit"
          }
        />
      </Grid>
      <CreateMasterModal
        // trigger={trigger}
        getValues={getValues}
        register={register}
        // handleSubmit={handleSubmit}
        errors={errors}
        resetForm={resetForm}
        watch={watch}
      />
    </>
  );
}
